<ngx-intl-tel-input
  [cssClass]="'custom'"
  [preferredCountries]="preferredCountries"
  [enableAutoCountrySelect]="true"
  [enablePlaceholder]="true"
  [searchCountryFlag]="true"
  [searchCountryField]="[
          SearchCountryField.Iso2,
          SearchCountryField.Name
        ]"
  [selectFirstCountry]="false"
  [selectedCountryISO]="selectedCountryISO"
  [maxLength]="15"
  [phoneValidation]="true"
  [separateDialCode]="separateDialCode"
  [customPlaceholder]="'010x-xxx-xxxx'"
  [numberFormat]="PhoneNumberFormat.National"
  name="phone"
  [formControl]="controlName"
>
</ngx-intl-tel-input>
<mat-error *ngIf="!phone.valid && phone.touched">{{'Please enter a valid phone number' | translate}}</mat-error>
